export default __webpack_public_path__ + "static/media/logo-dormakaba.131f08b0.png";